import Vue from "vue";
import Router from "vue-router";
require("expose-loader?$!jquery");

Vue.use(Router);

const commonRoutes = [{
        path: "/login",
        name: "login",
        component: () =>
            import ("../components/Login.vue"),
    },
    {
        path: "/",
        redirect: "/home"
    },
    {
        path: "/mobile/builder_login",
        name: "builder_login",
        component: () =>
            import ("../builder/Login.vue"),
    },
    {
        path: "/mobile/builder/home",
        name: "builder_home",
        component: () =>
            import ("../builder/Home.vue"),
    },
    //数据大屏
    {
        path: "/monitor",
        name: "monitor",
        component: () =>
            import ("../views/monitor.vue"),
    },
];

// 需要通过后台数据来生成的组件
export const asyncRoutes = {
    //为四川隐藏原主页
    home: {
        path: "home",
        name: "home",
        component: () =>
            import ("../views/eCharts/monitor.vue"),
    },
    data_info: {
        path: "data_info",
        name: "data_info",
        component: () =>
            import ("../views/eCharts/Home.vue"),
    },
    // home: {
    //     path: "home",
    //     name: "home",
    //     component: () =>
    //         import ("../views/valve/ValveManage.vue"),
    // },
    t1: {
        path: "t1",
        name: "t1",
        component: () =>
            import ("../views/T1.vue"),
    },
    password: {
        path: "password",
        name: "password",
        component: () =>
            import ("../views/Password.vue"),
    },
    msg: {
        path: "msg",
        name: "msg",
        component: () =>
            import ("../views/Msg.vue"),
    },
    userinfo: {
        path: "userinfo",
        name: "userinfo",
        component: () =>
            import ("../views/UserInfo.vue"),
    },
    down_instructions_menu: {
        path: "down_instructions_menu",
        name: "down_instructions_menu",
        component: () =>
            import ("../views/DownInstructions.vue"),
    },
    up_instructions_menu: {
        path: "up_instructions_menu",
        name: "up_instructions_menu",
        component: () =>
            import ("../views/UpInstructions.vue"),
    },
    address_menu: {
        path: "address_menu",
        name: "address_menu",
        component: () =>
            import ("../views/Address.vue"),
    },
    governing_body_menu: {
        path: "governing_body_menu",
        name: "governing_body_menu",
        component: () =>
            import ("../views/GoverningBody.vue"),
    },
    personnel_body_menu: {
        path: "personnel_body_menu",
        name: "personnel_body_menu",
        component: () =>
            import ("../views/Personnel.vue"),
    },
    meter_menu: {
        path: "meter_menu",
        name: "meter_menu",
        component: () =>
            import ("../views/Meter.vue"),
    },
    instructions_detailed_menu: {
        path: "instructions_detailed_menu",
        name: "instructions_detailed_menu",
        component: () =>
            import ("../views/InstructionsDetailed.vue"),
    },
    daily_use_record: {
        path: "daily_use_record",
        name: "daily_use_record",
        component: () =>
            import ("../views/DailyUseRecord.vue"),
    },
    instructions_detailed_produce: {
        path: "instructions_detailed_produce",
        name: "instructions_detailed_produce",
        component: () =>
            import ("../views/produce/InstructionsDetailedProduce.vue"),
    },
    open_account: {
        path: "open_account",
        name: "open_account",
        component: () =>
            import ("../views/OpenAccount.vue"),
    },
    recharge: {
        path: "recharge",
        name: "recharge",
        component: () =>
            import ("../views/Recharge.vue"),
    },
    order_create: {
        path: "order_create",
        name: "order_create",
        component: () =>
            import ("../views/CreateOrder.vue"),
    },
    abnormal_detailed: {
        path: "abnormal_detailed",
        name: "abnormal_detailed",
        component: () =>
            import ("../views/AbnormalDeatailed.vue"),
    },
    pipe_environment_params: {
        path: "pipe_environment_params",
        name: "pipe_environment_params",
        component: () =>
            import ("../views/PipeEnvironmentParams.vue"),
    },
    meter_state: {
        path: "meter_state",
        name: "meter_state",
        component: () =>
            import ("../views/MeterState.vue"),
    },
    valve_state: {
        path: "valve_state",
        name: "valve_state",
        component: () =>
            import ("../views/ValveState.vue"),
    },
    metering_data: {
        path: "metering_data",
        name: "metering_data",
        component: () =>
            import ("../views/MeteringData.vue"),
    },
    push_msg: {
        path: "push_msg",
        name: "push_msg",
        component: () =>
            import ("../views/PushMsg.vue"),
    },
    record_msg: {
        path: "record_msg",
        name: "record_msg",
        component: () =>
            import ("../views/RecordMsg.vue"),
    },
    set_up_repair_list: {
        path: "set_up_repair_list",
        name: "set_up_repair_list",
        component: () =>
            import ("../views/SetupPushAbnormal.vue"),
    },
    push_exception_config: {
        path: "push_exception_config",
        name: "push_exception_config",
        component: () =>
            import ("../views/PushExceptionConfig.vue"),
    },
    customer_response: {
        path: "customer_response",
        name: "customer_response",
        component: () =>
            import ("../views/CustomerResponse.vue"),
    },
    gas_appliances: {
        path: "gas_appliances",
        name: "gas_appliances",
        component: () =>
            import ("../views/GasAppliances.vue"),
    },
    meter_base_manage: {
        path: "meter_base_manage",
        name: "meter_base_manage",
        component: () =>
            import ("../views/meter/MeterBaseManage.vue"),
    },
    meter_box_manage: {
        path: "meter_box_manage",
        name: "meter_box_manage",
        component: () =>
            import ("../views/meter/MeterBoxManage.vue"),
    },
    meter_alarm_bind_manage: {
        path: "meter_alarm_bind_manage",
        name: "meter_alarm_bind_manage",
        component: () =>
            import ("../views/meter/MeterAlarmBindManage.vue"),
    },
    meter_box_down: {
        path: "meter_box_down",
        name: "meter_box_down",
        component: () =>
            import ("../views/meter/MeterBoxDown.vue"),
    },
    meter_work_info: {
        path: "meter_work_info",
        name: "meter_work_info",
        component: () =>
            import ("../views/meter/MeterWorkInfo.vue"),
    },
    meter_alarm_info: {
        path: "meter_alarm_info",
        name: "meter_alarm_info",
        component: () =>
            import ("../views/meter/MeterAlarmInfo.vue"),
    },
    meter_NBalarm_upload_info: {
        path: "meter_NBalarm_upload_info",
        name: "meter_NBalarm_upload_info",
        component: () =>
            import ("../views/meter/MeterNBAlarmUploadInfo.vue"),
    },
    meter_NBalarm_download_info: {
        path: "meter_NBalarm_download_info",
        name: "meter_NBalarm_download_info",
        component: () =>
            import ("../views/meter/MeterNBAlarmDownloadInfo.vue"),
    },
    meter_alarm_upload_info: {
        path: "meter_alarm_upload_info",
        name: "meter_alarm_upload_info",
        component: () =>
            import ("../views/meter/MeterAlarmUploadInfo.vue"),
    },
    meter_alarm_download_info: {
        path: "meter_alarm_download_info",
        name: "meter_alarm_download_info",
        component: () =>
            import ("../views/meter/MeterAlarmDownloadInfo.vue"),
    },
    meter_alarm_alarm_info: {
        path: "meter_alarm_alarm_info",
        name: "meter_alarm_alarm_info",
        component: () =>
            import ("../views/meter/MeterAlarmAlarmInfo.vue"),
    },
    company_manage: {
        path: "company_manage",
        name: "company_manage",
        component: () =>
            import ("../views/company/CompanyManage.vue"),
    },
    staff_manage: {
        path: "staff_manage",
        name: "staff_manage",
        component: () =>
            import ("../views/company/StaffManage.vue"),
    },
    valuation_manage: {
        path: "valuation_manage",
        name: "valuation_manage",
        component: () =>
            import ("../views/company/ValuationManage.vue"),
    },
    customer_manage: {
        path: "customer_manage",
        name: "customer_manage",
        component: () =>
            import ("../views/customer/CustomerManage.vue"),
    },
    address_manage: {
        path: "address_manage",
        name: "address_manage",
        component: () =>
            import ("../views/customer/AddressManage.vue"),
    },
    alarm_manage: {
        path: "alarm_manage",
        name: "alarm_manage",
        component: () => import ("../views/alarm/AlarmManage.vue"),
    },
    valve_upinstructions: {
        path: "valve_upinstructions",
        name: "valve_upinstructions",
        component: () =>
            import ("../views/ValveUpInstructions.vue"),
    },
    valve_upinstructions_2: {
        path: "valve_upinstructions_2",
        name: "valve_upinstructions_2",
        component: () =>
            import ("../views/valve/ValveUpInstructions2.vue"),
    },
    valvenb_upinstructions_2: {
        path: "valvenb_upinstructions_2",
        name: "valvenb_upinstructions_2",
        component: () =>
            import ("../views/valve/ValveNBUpInstructions2.vue"),
    },
    valve_upinstructions_3: {
        path: "valve_upinstructions_3",
        name: "valve_upinstructions_3",
        component: () =>
            import ("../views/ValveUpInstructions3.vue"),
    },
    valve_collection_2: {
        path: "valve_collection_2",
        name: "valve_collection_2",
        component: () =>
            import ("../views/ValveNBCollection.vue"),
    },
    valve_collection: {
        path: "valve_collection",
        name: "valve_collection",
        component: () =>
            import ("../views/ValveCollection.vue"),
    },
    valve_operation: {
        path: "valve_operation",
        name: "valve_operation",
        component: () =>
            import ("../views/valveOperation.vue"),
    },
    valvenb_operation: {
        path: "valvenb_operation",
        name: "valvenb_operation",
        component: () =>
            import ("../views/valveNBOperation.vue"),
    },
    valve_alarm: {
        path: "valve_alarm",
        name: "valve_alarm",
        component: () =>
            import ("../views/alarm/valveAlarm.vue"),
    },
    valve_alarm2: {
        path: "valve_alarm2",
        name: "valve_alarm2",
        component: () =>
            import ("../views/alarm/valveAlarm2.vue"),
    },
    valve_alarm3: {
        path: "valve_alarm3",
        name: "valve_alarm3",
        component: () =>
            import ("../views/alarm/valveAlarm3.vue"),
    },
    valve_alarm4: {
        path: "valve_alarm4",
        name: "valve_alarm4",
        component: () =>
            import ("../views/alarm/valveAlarm4.vue"),
    },
    valve_alarm5: {
        path: "valve_alarm5",
        name: "valve_alarm5",
        component: () =>
            import ("../views/alarm/valveAlarm5.vue"),
    },
    valvenb_alarm: {
        path: "valvenb_alarm",
        name: "valvenb_alarm",
        component: () =>
            import ("../views/alarm/valveNBAlarm.vue"),
    },
    valve_regular_upload: {
        path: "valve_regular_upload",
        name: "valve_regular_upload",
        component: () =>
            import ("../views/ValveRegularUpload.vue"),
    },
    valve_reboot: {
        path: "valve_reboot",
        name: "valve_reboot",
        component: () =>
            import ("../views/valveReboot.vue"),
    },
    valve_manage: {
        path: "valve_manage",
        name: "valve_manage",
        component: () =>
            import ("../views/valve/ValveManage.vue"),
    },
    valve_nb_manage: {
        path: "valve_nb_manage",
        name: "valve_nb_manage",
        component: () =>
            import ("../views/valve/ValveNBManage.vue"),
    },
    customer_gas_application: {
        path: "customer_gas_application",
        name: "customer_gas_application",
        component: () =>
            import ("../views/CustomerGasApplication.vue"),
    },
    eCharts_exception: {
        path: "eCharts_exception",
        name: "eCharts_exception",
        component: () =>
            import ("../views/eCharts/EChartsException.vue"),
    },
    eCharts_sales: {
        path: "eCharts_sales",
        name: "eCharts_sales",
        component: () =>
            import ("../views/eCharts/EChartsSales.vue"),
    },
    eCharts_flow: {
        path: "eCharts_flow",
        name: "eCharts_flow",
        component: () =>
            import ("../views/eCharts/EChartsFlow.vue"),
    },
    eChart_test: {
        path: "eChart_test",
        name: "eChart_test",
        component: () =>
            import ("../views/eCharts/echartTest.vue"),
    },
    valve_regularupload: {
        path: "valve_regularupload",
        name: "valve_regularupload",
        component: () =>
            import ("../views/valve/ValveRegularupload.vue"),
    },
    meter_regist: {
        path: "meter_regist",
        name: "meter_regist",
        component: () =>
            import ("../views/MeterRegist.vue"),
    },
    meter_export: {
        path: "meter_export",
        name: "meter_export",
        component: () =>
            import ("../views/MeterInfoExport.vue"),
    },
    import_file: {
        path: "import_file",
        name: "import_file",
        component: () =>
            import ("../views/file/ImportFile.vue"),
    },
    pipeline: {
        path: "pipeline",
        name: "pipeline",
        component: () =>
            import ("../views/threejs/Pipeline.vue"),
    },
    managep_permission: {
        path: "managep_permission",
        name: "managep_permission",
        component: () =>
            import ("../views/ManagePermission.vue"),
    },
    ladderPrice: {
        path: "ladderPrice",
        name: "ladderPrice",
        component: () =>
            import ("../views/LadderPrice.vue"),
    },
    meter_type: {
        path: "meter_type",
        name: "meter_type",
        component: () =>
            import ("../views/MeterType.vue"),
    },
    gastype: {
        path: "gastype",
        name: "gastype",
        component: () =>
            import ("../views/InfoGasType.vue"),
    },
    wx_debind: {
        path: "wx_debind",
        name: "wx_debind",
        component: () =>
            import ("../views/WxDebind.vue"),
    },
    meter_reset: {
        path: "meter_reset",
        name: "meter_reset",
        component: () =>
            import ("../views/MeterReset.vue"),
    },
    dictionary_manufacturer: {
        path: "dictionary_manufacturer",
        name: "dictionary_manufacturer",
        component: () =>
            import ("../views/DictionaryManufacturer.vue"),
    },
    dictionary_specifications: {
        path: "dictionary_specifications",
        name: "dictionary_specifications",
        component: () =>
            import ("../views/DictionarySpecifications.vue"),
    },
    instructions_detailed_for_list: {
        path: "instructions_detailed_for_list",
        name: "instructions_detailed_for_list",
        component: () =>
            import ("../views/InstructionsDetailedForList.vue"),
    },
    order_list: {
        path: "order_list",
        name: "order_list",
        component: () =>
            import ("../views/OrderList.vue"),
    },
    registe_profile: {
        path: "registe_profile",
        name: "registe_profile",
        component: () =>
            import ("../views/registProfile.vue"),
    },
    manage_down_queue: {
        path: "manage_down_queue",
        name: "manage_down_queue",
        component: () =>
            import ("../views/ManageDownQueue.vue"),
    },
    instructions_ladder_for_list: {
        path: "instructions_ladder_for_list",
        name: "instructions_ladder_for_list",
        component: () =>
            import ("../views/InstructionsLadderForList.vue"),
    },
    import_meter_history: {
        path: "import_meter_history",
        name: "import_meter_history",
        component: () =>
            import ("../views/ImportMeterHistory.vue"),
    },
    alarm_Off_Manage: {
        path: "alarm_Off_Manage",
        name: "alarm_Off_Manage",
        component: () =>
            import ("../views/alarm/alarmOffManage.vue"),
    },
    alarm_Leakage_Manage: {
        path: "alarm_Leakage_Manage",
        name: "alarm_Leakage_Manage",
        component: () =>
            import ("../views/alarm/alarmLeakageManage.vue"),
    },
    alarm_Condition_Threshold: {
        path: "alarm_Condition_Threshold",
        name: "alarm_Condition_Threshold",
        component: () =>
            import ("../views/alarm/alarmConditionThreshold.vue"),
    },
    alarm_Sensor_Manage: {
        path: "alarm_Sensor_Manage",
        name: "alarm_Sensor_Manage",
        component: () =>
            import ("../views/alarm/alarmSensorManage.vue"),
    },
    alarm_Server_Manage: {
        path: "alarm_Server_Manage",
        name: "alarm_Server_Manage",
        component: () =>
            import ("../views/alarm/alarmServerManage.vue"),
    },
    alarm_Heartbeat_Manage: {
        path: "alarm_Heartbeat_Manage",
        name: "alarm_Heartbeat_Manage",
        component: () =>
            import ("../views/alarm/alarmHeartbeatManage.vue"),
    },
    alarm_Record: {
        path: "alarm_Record",
        name: "alarm_Record",
        component: () =>
            import ("../views/alarm/AlarmRecord.vue"),
    },
    alarm_Record_Building: {
        path: "alarm_Record_Building",
        name: "alarm_Record_Building",
        component: () =>
            import ("../views/alarm/AlarmRecordBuilding.vue"),
    },
    alarm_Daily_Data: {
        path: "alarm_Daily_Data",
        name: "alarm_Daily_Data",
        component: () =>
            import ("../views/alarm/AlarmDailyData.vue"),
    },
    LPG_Daily_Data: {
        path: "LPG_Daily_Data",
        name: "LPG_Daily_Data",
        component: () =>
            import ("../views/alarm/LPGDailyData.vue"),
    },
    profile: {
        path: "profile",
        name: "profile",
        component: () =>
            import ("../views/valve/Profile.vue"),
    },
    // profile: {
    //     path: "profile",
    //     name: "profile",
    //     component: () =>
    //         import ("../views/valve/Profile.vue"),
    // },
    regulatory: {
        path: "regulatory",
        name: "regulatory",
        component: () =>
            import ("../views/regulatory/regulatory.vue"),
    },
    alarm_Resetting: {
        path: "alarm_Resetting",
        name: "alarm_Resetting",
        component: () =>
            import ("../views/alarm/alarmResetting.vue"),
    },
    AlarmNB_LeakCheck: {
        path: "AlarmNB_LeakCheck",
        name: "AlarmNB_LeakCheck",
        component: () =>
            import ("../views/alarm/AlarmNBLeakCheck.vue"),
    },
    alarm_down: {
        path: "alarm_down",
        name: "alarm_down",
        component: () =>
            import ("../views/alarm/AlarmDown.vue"),
    },
    alarm_downNBandWIFI: {
        path: "alarm_downNBandWIFI",
        name: "alarm_downNBandWIFI",
        component: () =>
            import ("../views/alarm/AlarmDownNBandWIFI.vue"),
    },
    alarm_work_info: {
        path: "alarm_work_info",
        name: "alarm_work_info",
        component: () =>
            import ("../views/alarm/AlarmWorkInfo.vue"),
    },
};

const createRouter = () =>
    new Router({
        //mode: "history",
        routes: commonRoutes,
    });

const router = createRouter();

export function resetRouter() {
    const newRouter = createRouter();
    router.matcher = newRouter.matcher;
}

export default router;